import React, {ReactElement, SVGProps} from 'react';
import cn from 'classnames';
import Tooltip from '@material-ui/core/Tooltip';

// Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc.
interface DoubleRightChevronIconProps extends SVGProps<SVGSVGElement> {
  tooltip?: ReactElement | string;
}

export const DoubleRightChevronIcon: React.FC<DoubleRightChevronIconProps> = props => {
  return (
    <Tooltip title={props.tooltip ?? ''}>
      <svg
        {...props}
        className={cn(props.className, 'icon double-right-chevron')}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 448 512">
        <path d="M233.3 239.4l-176-184C48.19 45.84 33 45.49 23.41 54.65C18.47 59.37 16 65.68 16 71.99c0 5.969 2.219 11.94 6.656 16.59L182.8 256l-160.1 167.4c-9.125 9.594-8.844 24.78 .75 33.94c9.594 9.156 24.78 8.813 33.94-.75l176-184C242.2 263.3 242.2 248.7 233.3 239.4zM425.3 239.4l-176-184C240.2 45.84 225 45.49 215.4 54.65C210.5 59.37 208 65.68 208 71.99c0 5.969 2.219 11.94 6.656 16.59L374.8 256l-160.1 167.4c-9.125 9.594-8.844 24.78 .75 33.94c9.594 9.156 24.78 8.813 33.94-.75l176-184C434.2 263.3 434.2 248.7 425.3 239.4z" />
      </svg>
    </Tooltip>
  );
};
